/**
 * Détection d'environnement côté navigateur — qualif et prod ne doivent jamais se mélanger.
 */

/** Frontends qualif connus (sous-domaines QA uniquement). */
export const QUALIF_FRONTEND_HOSTS = new Set([
  'qa001.inventwee.airzk.fr',
  'inventwee-qualif.airzk.fr',
]);

/** Frontends production connus. */
export const PROD_FRONTEND_HOSTS = new Set([
  'app.inventwee.com',
  'inventwee.airzk.fr',
]);

export function getBrowserHostname(): string | undefined {
  return typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : undefined;
}

export function isQualifEnvironment(): boolean {
  const hostname = getBrowserHostname();
  if (hostname && QUALIF_FRONTEND_HOSTS.has(hostname)) {
    return true;
  }
  if (import.meta.env.VITE_APP_ENV === 'qualif') {
    return true;
  }
  return false;
}

export function isProdEnvironment(): boolean {
  const hostname = getBrowserHostname();
  if (hostname && PROD_FRONTEND_HOSTS.has(hostname)) {
    return true;
  }
  if (import.meta.env.VITE_APP_ENV === 'production') {
    return true;
  }
  return false;
}
